import React from 'react';

import {/*BreadCrumbs,*/ PageTitle} from '../../../components';
import Navigation from "./Navigation";

const Body = ({children}) => (
  <div className="main-body">
    <div className="container content">
      <PageTitle />
      {/*<BreadCrumbs />*/}
      <div className="row">
        <div className="body-main-content">
          {children}
        </div>
        <div className="body-right-content">
          <Navigation/>
        </div>
      </div>
    </div>
  </div>
);

export default Body;


// WEBPACK FOOTER //
// ./src/modules/layout/components/Body.js